var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "address"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8029 15.6971C15.7171 16.6114 16.9571 17.125 18.25 17.125C18.8902 17.125 19.5241 16.9989 20.1156 16.7539C20.707 16.5089 21.2445 16.1498 21.6971 15.6971C22.1498 15.2445 22.5089 14.707 22.7539 14.1156C22.9989 13.5241 23.125 12.8902 23.125 12.25C23.125 10.9571 22.6114 9.71709 21.6971 8.80285C20.7829 7.88861 19.5429 7.375 18.25 7.375C16.9571 7.375 15.7171 7.88861 14.8029 8.80285C13.8886 9.71709 13.375 10.9571 13.375 12.25C13.375 13.5429 13.8886 14.7829 14.8029 15.6971ZM18.25 34.2435C18.2046 34.1912 18.1553 34.1343 18.1024 34.0729C17.7703 33.6874 17.2949 33.1255 16.7242 32.4222C15.5822 31.0151 14.0603 29.0448 12.5395 26.7907C11.0177 24.5351 9.50303 22.0045 8.37036 19.4762C7.23476 16.9414 6.5 14.4457 6.5 12.25C6.5 9.13371 7.73794 6.14505 9.9415 3.9415C12.145 1.73794 15.1337 0.5 18.25 0.5C21.3663 0.5 24.355 1.73794 26.5585 3.9415C28.7621 6.14505 30 9.13371 30 12.25C30 14.4457 29.2652 16.9414 28.1296 19.4762C26.997 22.0045 25.4823 24.5351 23.9605 26.7907C22.4397 29.0448 20.9178 31.0151 19.7758 32.4222C19.2051 33.1255 18.7297 33.6874 18.3976 34.0729C18.3447 34.1343 18.2954 34.1912 18.25 34.2435Z",
    stroke: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressRed);
export default __webpack_public_path__ + "static/media/address_red.1b94acc19500ad6bb148a8fa5bb37087.svg";
export { ForwardRef as ReactComponent };